import { DateTime } from 'luxon';

export const YearDaysFromNow = (date: Date) =>
  DateTime.fromJSDate(date).plus({ days: 365 }).toJSDate();

